import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h2>Dashboard</h2>
      <p>Welcome to your dashboard!</p>
    </div>
  );
};

export default Dashboard;




//import React, { useEffect, useState } from "react";
//
//const Dashboard = () => {
//  const [data, setData] = useState("");
//
//  useEffect(() => {
//    const fetchData = async () => {
//      const token = localStorage.getItem("authToken"); // Get stored JWT
//      const responseLatestTest = await axios.get("http://localhost:8080/prep/latest", {
//          params: {
//              topic: 'MATH',
//              testType: "WEEKLY"
//          },
//          headers: { Authorization: `Bearer ${token}` }
//      });
//      console.log("Latest test record fetched from backend is: ", responseLatestTest.data);
//
//      setData(responseLatestTest.data);
//    };
//
//    fetchData();
//  }, []);
//
//  return <div>Dashboard Data: {data}</div>;
//};
//
//export default Dashboard;